import { EventBus } from "../../../eventbus";

export default {
  props: {
    id: String,
  },
  data() {
    return {
      show: false,
      showClose: true,
    };
  },
  created() {
    this.showClose = true;

    //listen for open and close events (from other top options)
    EventBus.$on(`top-options-show`, (data) => {
      if (this.id === data.id) {
        //is for here so set the show value
        this.setShow(data.show);
      } else {
        //hides all other topOptions
        this.setShow(false);
      }
    });

    EventBus.$on(`search`, () => {
      this.showClose = false;
    });

    EventBus.$on(`search-done`, () => {
      this.showClose = false;
    });

    EventBus.$on(`search-clear`, () => {
      this.showClose = true;
    });
  },
  methods: {
    closeSelf() {
      EventBus.$emit(`top-options-show`, { id: this.id, show: false });
    },
    setShow(newShow) {
      if (newShow === "toggle") {
        this.show = !this.show;
      } else {
        this.show = newShow;
      }
    },
  },
};
